var $84925f526f90eebd$exports = {};
$84925f526f90eebd$exports = {
  "removeButtonLabel": "\u0625\u0632\u0627\u0644\u0629",
  "removeDescription": "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0645\u0641\u062A\u0627\u062D DELETE \u0644\u0625\u0632\u0627\u0644\u0629 \u0639\u0644\u0627\u0645\u0629."
};
export { $84925f526f90eebd$exports as default };